import Share from './views/share.c';
export default Share;
